import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import styled from 'styled-components'
import { I18n } from 'common'
import { breakpoints } from '../../../theme/breakpoints'

const Unavailable = observer((): ReactElement => {
  return (
    <TrackingContainer>
      <OrderNumberContainer>
        <OrderNumber>
          <I18n name="orderNumber" />
          <OrderNumberContent>#23WO090989</OrderNumberContent>
        </OrderNumber>
        <OrderDate>Ordered on Jan 25 2022 at 1:14 PM EST</OrderDate>
      </OrderNumberContainer>
      <HorizontalDivider />
      <UnavailableMessage>
        This order was placed via phone, walk-in, or through another
        application.
      </UnavailableMessage>
    </TrackingContainer>
  )
})

export default Unavailable

const HorizontalDivider = styled.div`
  width: 150%;
  height: 1.3px;
  background-color: #e5e4e1;
  position: absolute;
  margin-left: -50px;

  @media screen and (min-width: ${breakpoints.laptop}px) {
    width: 80%;
    margin: 0px;
  }
`

const UnavailableMessage = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-top: 20px;
  /* or 143% */

  /* Black */

  color: #000000;
`

const TrackingContainer = styled.div``

const OrderNumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  font-size: 14px;
`

const OrderNumber = styled.p`
  display: flex;
  font-weight: bold;
  margin: 0px;
`

const OrderNumberContent = styled.p`
  font-weight: normal;
  margin: 0px 0px 0px 3px;
`

const OrderDate = styled.p`
  font-size: 14px;
`
